<template>
    <div class="Footerbottom">
        <div class="FooterMenuInfo">
            <div class="FooterMenu">
                <ul class="IndustrialChain">
                    <li class="canyelian">产业链</li>
                    <li><router-link to='/industrialChain/serviceContent'>店铺代运营</router-link></li>
                    <li><router-link to='/industrialChain/digitalMarketing'>数字营销</router-link></li>
                    <li><router-link to='/industrialChain/ITSolutions'>IT解决方案</router-link></li>
                </ul>
                <ul class="HelpCenter">
                    <li>帮助中心</li>
                    <!-- <li><router-link to='/softwareProduct'>服务流程</router-link></li> -->
                    <li><router-link to='/commonProblem'>常见问题</router-link></li> 
                    <li><router-link to='/downloadCenter'>下载中心</router-link></li>
                    <li><router-link to='/privacyPolicy'>隐私政策</router-link></li>
                </ul>
                <ul class="NewsCenter">
                    <li>新闻中心</li>
                    <li><router-link to='/dynamicNews/companyNews'>公司新闻</router-link></li>
                    <!-- <li><router-link to='/dynamicNews/companyNews'>行业新闻</router-link></li> -->
                </ul>
                <ul class="BrandCustomers">
                    <li><router-link to='/brandCustomers'>品牌客户</router-link></li>
                    <li></li>
                    <li></li>
                    <li></li>
                </ul>
                <ul class="AboutUs">
                    <li>关于我们</li>
                    <li><router-link to='/companyProfile'>公司简介</router-link></li>
                    <li><router-link to='/jobOpportunities'>加入我们</router-link></li>
                    <li><router-link to='/contactUs'>联系我们</router-link></li>
                </ul>
            </div>
            <div class="FooterInfo">
                <span>友情链接: 上海胤石网络科技有限公司</span>
                <span>Copyright © 2021 - 2024 胤石科技</span>
                <span><a href="https://beian.miit.gov.cn/" style="color:#fff;">沪ICP备2020035165号</a> </span>
            </div>
        </div>
        <div class="FooterPublicNumber">
            <img src="@/assets/img/erweima_03.jpg">
            <div>胤石公众号</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'YinshiOffcialwebsiteFooter',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>
// 底部
.Footerbottom{
    background: #0f244f;
    padding:0px 270px;
    display: flex;
    justify-content: space-between;
    // position: absolute;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // height: 300px;
    // 菜单和介绍
    .FooterMenuInfo{
        overflow:hidden;
        // 菜单
        .FooterMenu{
            display: flex;
            margin-top: 47px;
            ul > li:nth-child(1){
                font-size: 18px;
                font-weight: 700;
                color: #ffffff;
                border-bottom: 0.0625rem solid rgb(255 255 255 / 75%);
                white-space: nowrap;
                padding-bottom: 10px;
                a{
                    color: #ffffff;
                    font-size: 18px;
                    font-weight: 700;
                }
            }
            ul > li:nth-child(n+2){
                a{
                    display: inline-block;
                    font-size: 14px;
                    font-weight: 400;
                    color: #ffffff;
                    margin-top: 19px;
                    white-space: nowrap;
                    padding-bottom: 1px;
                    transition:.2s all;
                    border-bottom: 1px solid transparent;
                }
                a:hover{
                    // border-bottom: 1px solid #fff;
                    color:#7492D7;
                }
            }
            // 产业链
            .canyelian{
                width: 58px;
            }
            // 帮助中心    // 新闻中心    // 品牌客户    // 关于我们
            .HelpCenter,.NewsCenter,.BrandCustomers,.AboutUs{
                margin-left: 117px;
            }
        }
        // 页脚公司信息
        .FooterInfo{
            font-size: 12px;
            font-weight: 400;
            color: #ffffff;
            padding: 11px 0px;
            width: 814px;
            border-top: 2px solid #ffffff;
            margin-top: 60px;
            span:nth-child(n+2){
                margin-left: 54px;
            }
            a{
                font-size: 12px ;
            }
        }
    }
    .FooterPublicNumber{
        margin-right: 0px;
        padding-top: 48px;
        padding-bottom: 58px;
        img{
            width: 193px;
            height: 193px;
        }
        div{
            font-size: 14px;
            font-family: Microsoft YaHei, Microsoft YaHei-Bold;
            font-weight: 700;
            text-align: center;
            color: #dddddd;
            margin-top: 13px;
        }
    }
    // .FooterMenu
    // .IndustrialChain
    // .HelpCenter
    // .NewsCenter
    // .BrandCustomers
    // .AboutUs
}
</style>
